module.exports = __webpack_public_path__ + "static/media/LOGO_CHAPADA_DOMMUS_W2.26ee63ff.svg";